export default __webpack_public_path__ + "static/media/fa-solid-900.3ceb50e7.woff2";